// The page-scroll lock the full-screen follow-up popups put on <body> (App.css `body.overflow-hidden`).
// One module so the flow that sets it can always take it off again (CU-869fnzwvt, R6): a lock
// that is added and never removed leaves the whole CRM unscrollable. Pure DOM, no React.
//
// lockBodyScroll() returns the way to undo exactly what it did. If something else already held
// the lock (or locked <html>), releasing leaves their lock alone: only our own change is undone.
const LOCK_CLASS = 'overflow-hidden';

export function lockBodyScroll() {
    if (typeof document === 'undefined' || !document.body) return () => {};
    const heldByOthers = document.body.classList.contains(LOCK_CLASS);
    document.body.classList.add(LOCK_CLASS);
    let released = false;
    return () => {
        if (released) return;
        released = true;
        if (!heldByOthers) document.body.classList.remove(LOCK_CLASS);
    };
}
